module.exports = __webpack_public_path__ + "media/images/ca_flag-237c7b13f0d06c16e683ebc3a83932cc.png";